var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDocumentIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.7207 40.2388C32.2476 40.2388 39.9707 32.5157 39.9707 22.9888C39.9707 13.4619 32.2476 5.73877 22.7207 5.73877C13.1938 5.73877 5.4707 13.4619 5.4707 22.9888C5.4707 32.5157 13.1938 40.2388 22.7207 40.2388Z",
    fill: "#272727"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.6289 14.1953V18.5977C23.6289 19.098 23.8277 19.5779 24.1815 19.9318C24.5353 20.2856 25.0152 20.4844 25.5156 20.4844H29.918V29.918C29.918 30.4184 29.7192 30.8983 29.3654 31.2521C29.0115 31.6059 28.5316 31.8047 28.0312 31.8047H17.9688C17.4684 31.8047 16.9885 31.6059 16.6346 31.2521C16.2808 30.8983 16.082 30.4184 16.082 29.918V16.082C16.082 15.5816 16.2808 15.1017 16.6346 14.7479C16.9885 14.3941 17.4684 14.1953 17.9688 14.1953H23.6289ZM24.8867 14.2689V18.5977C24.8867 18.7645 24.953 18.9244 25.0709 19.0424C25.1889 19.1603 25.3488 19.2266 25.5156 19.2266H29.8444C29.7561 18.9193 29.5912 18.6395 29.3652 18.4134L25.6999 14.7488C25.4739 14.5225 25.1941 14.3573 24.8867 14.2689V14.2689Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentIcon);
export default __webpack_public_path__ + "static/media/document-icon.c5bd682ce7ca847bdb92c249c0540a6e.svg";
export { ForwardRef as ReactComponent };